<template>
  <div class="data-grid-wrapper" :style="{height: bodyHeight, width: '100%'}">
    <Card class="data-grid" :class="{'auto': !isDesktop}" :bordered="false" :dis-hover="disHover" :style="{height: `${isDesktop ? '100%' : ''}`}">
        <searchbar ref="searchbar"
          @trigger="__calcContentHeight"
          @search="select(true)"
          v-model="model"
          search
          :showButton="showButton"
          :items="items"/>
          <div class="data-grid-body" :style="{height: height}">
            <div class="data-grid-body-alert" ref="alert" v-show="$slots.extra || $scopedSlots.extra">
              <slot name="extra" :extra="pageModel.extra" :page="pageModel.page" :query="pageModel.query"/>
            </div>
            <div class="data-grid-operator" ref="operator" v-show="$slots.operator || enableToolbar">
              <div class="data-grid-operator-lt"><slot name="operator"/></div>
              <div class="data-grid-operator-rt data-grid-operator-toolbar" v-if="enableToolbar">
                <export v-if="exportApi" :api="exportApi" :query="pageModel.query" :columns="tableColumns"/>
                <size @change="onSizeChange"/>
                <refresh @click="select"/>
                <columns v-if="tableColumns && tableColumns.length" :columns="columns" @change="onColumnsChange"/>
              </div>
            </div>
            <template>
              <el-table :data="list"
                :size="size"
                :height="fixedHeight ? fixedHeight : !autoHeight && isDesktop ? tableHeight : undefined"
                ref="table"
                :lazy="lazy"
                :border="bordered"
                :load="onLoad"
                :row-key="autoId ? '$id' : rowKey"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                stripe
                v-loading="loading"
                @selection-change="handleSelectionChange"
                @sort-change="handleSortChange"
                highlight-current-row>
                <template v-if="tableColumns && tableColumns.length > 0">
                  <template v-for="column in tableColumns">
                      <el-table-column  v-if="!column.render"
                        :key="column.id"
                        :type="column.type"
                        :label="column.label"
                        :prop="column.prop"
                        :align="column.align ? column.align : 'center'"
                        :header-align="column.headerAlign ? column.headerAlign : 'center'"
                        :width="column.width"
                        :sortable="column.sortable"
                        :index="column.index"
                        :column-key="column.columnKey"
                        :min-width="column.minWidth"
                        :fixed="column.fixed"
                        :render-header="column.renderHeader"
                        :sort-method="column.sortMethod"
                        :sort-by="column.sortBy"
                        :sort-orders="column.sortOrders"
                        :resizable="column.resizable"
                        :formatter="column.formatter"
                        :class-name="column.className"
                        :selectable="column.selectable"
                        :reserve-selection="column.reserveSelection"
                        :filters="column.filters"
                        :filter-placement="column.filterPlacement"
                        :filter-multiple="column.filterMultiple"
                        :filter-method="column.filterMethod"
                        :filtered-value="column.filteredValue"
                        show-overflow-tooltip>
                      </el-table-column>
                      <el-table-column v-else
                        :key="column.id"
                        :label="column.label"
                        :prop="column.prop"
                        :align="column.align ? column.align : 'center'"
                        :header-align="column.headerAlign ? column.headerAlign : 'center'"
                        :width="column.width"
                        :sortable="column.sortable"
                        :index="column.index"
                        :column-key="column.columnKey"
                        :min-width="column.minWidth"
                        :fixed="column.fixed"
                        :render-header="column.renderHeader"
                        :sort-method="column.sortMethod"
                        :sort-by="column.sortBy"
                        :sort-orders="column.sortOrders"
                        :resizable="column.resizable"
                        :formatter="column.formatter"
                        :class-name="column.className"
                        :selectable="column.selectable"
                        :reserve-selection="column.reserveSelection"
                        :filters="column.filters"
                        :filter-placement="column.filterPlacement"
                        :filter-multiple="column.filterMultiple"
                        :filter-method="column.filterMethod"
                        :filtered-value="column.filteredValue"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                          <render-func :render="column.render" :scope="scope"/>
                        </template>
                      </el-table-column>
                  </template>
                </template>
                <slot :scope="pageModel"/>
              </el-table>
              <div class="data-grid-pagination" :style="{marginTop: '12px', textAlign: isDesktop ? 'left' : 'center' }" v-show="page">
                <el-pagination
                  :background="isDesktop"
                  style="display:inline-block;"
                  small
                  @size-change="onPageSizeChange"
                  @current-change="onCurrentPageChange"
                  :disabled="loading"
                  :page-sizes="pager"
                  :page-size="pageSize"
                  :current-page="pageNum"
                  :layout="isDesktop ? 'total, sizes, prev, pager, next, jumper' : 'prev, pager, next'"
                  :total="total">
                </el-pagination>
              </div>
            </template>
        </div>
        <slot name="dialog"/>
    </Card>
  </div>
</template>

<script>
import Mixins from './data-grid-mixins.js'
import { addResizeListener, removeResizeListener } from '../utils/resize-observer'
import bus from './bus'
import Searchbar from './searchbar'
import { Refresh, Export, Size, Columns } from './toolbar'
import ResponsiveMixins from '../mixins/responsive-observer'
export default {
  name: 'v-data-grid',
  mixins: [Mixins, ResponsiveMixins],
  inject: {
    tabItem: {
      from: 'tabItem',
      default: null
    }
  },
  components: {
    Searchbar,
    Refresh,
    Export,
    Size,
    Columns,
    RenderFunc: {
      functional: true,
      props: {
        render: {
          type: Function
        },
        scope: {
          type: Object
        }
      },
      render (h, ctx) {
        let { render, scope } = ctx.props
        return render(h, scope)
      }
    }
  },
  props: {
    diffHeight: { // 计算表格高度时需要减去的高度
      type: Number,
      default: 0
    },
    page: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      size: 'small',
      alertHeight: 0,
      opeartorHeight: 0,
      loading: false,
      model: {},
      pageModel: {
        extra: {},
        page: {},
        query: {}
      },
      sort: {
        order: '',
        prop: ''
      },
      list: [],
      query: {},
      pageNum: 1,
      total: 0,
      height: 0,
      id: 0,
      rowId: '$id',
      $pageSize: 25,
      isMobile: false,
      isDesktop: false,
      isPad: false,
      $columns: [],
      blackList: []
    }
  },
  computed: {
    bodyHeight () {
      if (!this.isDesktop) return 'auto'
      if (this.diffHeight !== undefined) return `calc(100% - ${this.diffHeight}px)`
      else return '100%'
    },
    tableHeight () {
      if (!this.isDesktop) return 'auto'
      if (this.page) return `calc(100% - ${52 + this.alertHeight}px)`
      else return `calc(100% - 16px)`
    },
    cardBodyStyle () {
      return this.isDesktop ? 'height: 100%;' : ''
    },
    tableColumns () {
      if (this.blackList.length) {
        return this.columns.filter(column => this.blackList.findIndex(v => v === column.label) !== -1)
      } else {
        return this.columns.filter(column => !column.hidden)
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) this.model = val
      }
    },
    model: {
      deep: true,
      handler () {
        this.$emit('input', this.model)
      }
    },
    opeartorHeight () {
      this.__calcContentHeight()
    },
    pageSize: {
      immediate: true,
      handler (val) {
        this.$pageSize = val
      }
    }
    // columns: {
    //   deep: true,
    //   immediate: true,
    //   handler (columns) {
    //     if (columns.length) {
    //       this.$columns = columns
    //       // this.$columns.forEach(item => {
    //       //   Object.assign(item, {hidden: false})
    //       // })
    //     }
    //   }
    // }
  },
  methods: {
    onColumnsChange (values) {
      this.blackList = values
      this.doLayout()
    },
    onSizeChange (value) {
      this.size = value
      this.doLayout()
    },
    isEmpty () {
      return this.total === 0
    },
    isReady () {
      return !!this.init
    },
    hideLoading () {
      this.loading = false
    },
    handleSortChange ({column, prop, order}) {
      const sort = {}
      sort.order = order
      if (order) sort.prop = prop
      else sort.prop = ''
      const $meta = {
        column,
        prop,
        order
      }
      this.$emit('on-sort-change', sort, $meta)
    },
    // export (api) {
    //   return new Promise(resolve => {
    //     this.$api(api, this.query).then(url => resolve(url))
    //   })
    // },
    genId (list = []) {
      if (!this.autoId) return
      list.forEach(item => {
        this.$set(item, '$id', ++this.id)
      })
    },
    // 对选
    handleSelectionChange (val) {
      this.$emit('on-selection-change', val)
    },
    clearSelection () {
      if (this.$refs.table) {
        this.$refs.table.clearSelection()
      }
    },
    /**
     * @description 查询
     * @param {Boolean} reload 是否从第一页开始查询
     * @author yangyu
     */
    select (reload = false, currentRow = '') {
      if (this.api) {
        if (reload) this.pageNum = 1
        this.loading = true
        let params = this.params && typeof this.params === 'function' ? this.params(this.model) : this.params
        return this.$api(this.api, {
          pageNum: this.page ? this.pageNum : null,
          pageSize: this.page ? this.$pageSize : null,
          ...params
        }).then(res => {
          if (!res) res = {}
          this.pageModel = JSON.parse(JSON.stringify(res))
          this.$emit('update:pageModel', this.pageModel)
          // this.response = JSON.parse(JSON.stringify(res))
          if (res && this.page && res.page) {
            this.genId(res.page.list)
            this.list = res.page.list
            this.pageNum = res.page.pageNum
            // this.pageSize = res.page.pageSize
            this.total = res.page.total
            this.$emit('get-list', res.page.list)
          } else {
            if (!Array.isArray(res)) res = []
            this.genId(res)
            this.list = res
          }
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.bodyWrapper.scrollTop = 0
              // 设置当前高亮
              if (currentRow && !this.autoId && typeof this.rowKey === 'string') {
                let currentIndex = this.list.findIndex(row => row[this.rowKey] === currentRow)
                if (currentIndex !== -1) {
                  this.$refs.table.setCurrentRow(this.list[currentIndex])
                }
              }
            }
          })
          this.loading = false
        }).catch(err => {
          if (process.env.NODE_ENV === 'development') console.error(err)
          this.$tips(err, 'error')
          this.loading = false
        })
      }
    },
    clear () {
      this.pageNum = 1
      this.list = []
      this.total = 0
    },
    /**
     * @description 加载子节点数据
     * @author yangyu
     */
    onLoad (tree, treeNode, resolve) {
      if (!this.lazyLoadApi) return
      let params = {}
      if (Array.isArray(this.lazyLoadParamNames)) {
        this.lazyLoadParamNames.forEach(k => {
          params[k] = tree[k]
        })
      } else {
        Object.keys(this.lazyLoadParamNames).forEach(k => {
          params[this.lazyLoadParamNames[k]] = tree[k]
        })
      }
      this.$api(this.lazyLoadApi, params).then(res => {
        if (res) {
          this.genId(res)
          resolve(res)
        }
      }).catch(err => {
        if (process.env.NODE_ENV === 'development') {
          console.error(err)
        }
        this.$tips(err, 'error')
      })
    },
    onCurrentPageChange (val) {
      this.pageNum = val
      this.select()
    },
    onPageSizeChange (val) {
      this.$pageSize = val
      this.select()
    },
    __calcContentHeight () {
      if (!this.isDesktop) {
        this.height = 'auto'
        return
      }
      this.$nextTick(() => {
        if (!this.$refs.searchbar) {
          this.height = `calc(100% - ${this.opeartorHeight}px)`
        } else {
          this.height = `calc(100% - ${this.$refs.searchbar.$el.offsetHeight + this.opeartorHeight}px)`
        }
        setTimeout(() => {
          if (this.$refs.table) this.$refs.table.doLayout()
        }, 20)
      })
    },
    onResize () {
      this.__calcContentHeight()
    },
    onAlertResize () {
      this.alertHeight = this.$refs.alert.offsetHeight
    },
    onOpearatorResize () {
      this.opeartorHeight = this.$refs.operator.offsetHeight
    },
    doLayout () {
      this.$nextTick(() => {
        this.__calcContentHeight()
      })
    }
    // 表格相关方法
  },
  created () {
    if (this.defaultLoading) this.loading = true
    if (this.autoId) this.rowId = '$id'
    else this.rowId = this.rowKey
  },
  mounted () {
    if (this.tabItem) this.tabItem.setDataGrid(this)
    if (this.autoSearch) {
      this.select(true)
    }
    this.$nextTick(() => {
      this.init = true
      this.table = this.$refs.table
      this.__calcContentHeight()
      bus.$on('on-tab-change', this.onResize)
      if (this.$refs.alert) {
        addResizeListener(this.$refs.alert, this.onAlertResize)
      }
      if (this.$refs.operator) {
        addResizeListener(this.$refs.operator, this.onOpearatorResize)
      }
      if (this.$refs.searchbar) {
        addResizeListener(this.$refs.searchbar.$el, this.__calcContentHeight)
      }
    })
    this.bindResponsiveObserver()
  },
  beforeDestroy() {
    if (this.$refs.alert) {
      removeResizeListener(this.$refs.alert, this.onAlertResize)
    }
    if (this.$refs.operator) {
      removeResizeListener(this.$refs.operator, this.onOpearatorResize)
    }
    if (this.$refs.searchbar) {
      removeResizeListener(this.$refs.searchbar.$el, this.__calcContentHeight)
    }
    this.unbindResponsiveObserver()
  }
}
</script>

<style lang="less">
.data-grid {
  transition: unset!important;
  .ivu-card-body {
    height: 100%;
  }
  &.auto {
    .ivu-card-body {
      height: unset;
    } 
  }
  &-operator {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .data-grid-operator-toolbar{
      display: flex;
      align-items: center;
    }
  }
  &-body {
    .el-pagination {
      * {
        vertical-align: middle!important;
      }
      .el-pagination__sizes {
        height: auto!important;
        line-height: initial!important;
      }
    }
  }
  &-pagination {
    .el-input__inner {
      padding-right: 3px!important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/framework/data-grid/data-grid.vue